import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { isMute, muteDelete, mutePost, getMuteList, getMutedList } from '../service/MuteService';
import { LoginInfo } from '../App';
import { useTranslation } from "react-i18next";
import RegistOrLogin from './RegistOrLogin';

const MuteButton = (props) => {
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const location = useLocation()

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const [mute,setMute] = useState(false)

    useEffect(() => {
        setMute(props.mute)
    },[props.mute])

    let userId = props.userId
    let userName = props.userName
    let muteButton

    if(mute){
        muteButton = <span variant="outline-secondary" className='d-block' onClick={(e) => {
            setOkButtonShow(true)
            dialog("確認",
            <Container className='text-center'>
                {t("common.unmute")}<br /><br />
                <Image loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+userId+".jpg"} style={{width:"100px",height:"auto",borderRadius:"50%"}} /><br />
                {userName}
            </Container>)
        }}><Icon.Person /> {t("common.muted")}</span>
    } else {
        muteButton = <span variant="danger" className='d-block' onClick={(e) => {
            if(loginInfo.result === false){
                dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
                return
            }
            if(loginInfo.userId === userId){
                dialog("エラー","自分自身はミュートできません。")
                return
            }
            mutePost(userId,dialog).then(r=>{
                if(r){
                    setMute(true)
                }
            })
        }}><Icon.PersonX /> {t("common.muteUs")}</span>
    }
    let okButton = ""
    if(okButtonShow){
        okButton = <Button onClick={() => {
            setShow(false)
            muteDelete(userId,dialog).then(r=>{
                if(r){
                    setMute(false)
                }
                setOkButtonShow(false)
            })
        }} >OK</Button>
    }

    return(
        <>{muteButton}<Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton}/></>
    )
}

export default MuteButton;
